import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'Components';
import { Link } from 'react-router-dom';
import './MobileStrip.css';

const MobileStrip = props => (
  <div className="mobile-strip">
    { props.left ?
      <Link to={props.left}>
        <Icon icon="chevron_left" />
      </Link>
      :
      <span />
    }
    <span>{props.title}</span>
    { props.right ?
      <Link to={props.right}>
        <Icon icon="chevron_right" />
      </Link>
      :
      <span />
    }
  </div>
);

MobileStrip.propTypes = {
  left: PropTypes.string,
  title: PropTypes.string,
  right: PropTypes.string,
};

export default MobileStrip;



// WEBPACK FOOTER //
// ./src/components/MobileStrip/MobileStrip.jsx